export const isAuthenticated = (TokenKey) => {
  if (TokenKey) return true;
  return false;
};
